(() => {
  const hubs = document.querySelectorAll('[data-policy-hub]');

  hubs.forEach((hub) => {
    hub.querySelectorAll('[data-policy-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const selector = link.getAttribute('href');
        const panel = selector?.startsWith('#') ? document.getElementById(selector.slice(1)) : null;
        if (!panel) return;

        event.preventDefault();
        panel.open = true;
        hub.querySelectorAll('[data-policy-link]').forEach((item) => item.removeAttribute('aria-current'));
        link.setAttribute('aria-current', 'true');
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', selector);
      });
    });

    if (window.location.hash) {
      const panel = document.getElementById(window.location.hash.slice(1));
      if (panel?.matches('[data-policy-panel]')) panel.open = true;
    }
  });
})();
